import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../../../shared/services/logging';
import { InvoiceProperty } from './invoice-property.model';
import { EfaactDataService } from '../../../efaact.data-service';

export const entityName = 'InvoiceProperty';
@Injectable({ providedIn: 'root' })
export class InvoicePropertyDataService extends EfaactDataService<InvoiceProperty> {
    mapItems(item: InvoiceProperty): InvoiceProperty {
        return {
            id: item.Invoicepropertyid,
            ...item
        };
    }

    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }
}
